import { AccountActivatePage as AccountActivateFeaturePage } from '@egw/features-account'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const AccountActivatePage: FC = () => {
  return (
    <Layout>
      <AccountActivateFeaturePage />
    </Layout>
  )
}
